import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "@/store";
import { selectParams, selectStringParam } from "@/store/selectors";

const selectPoints = (state: RootState) => state.work.points;
const selectTasks = (state: RootState) => state.work.tasks;
const selectCheckoutList = (state: RootState) => state.work.checkoutList;
const selectCheckoutCompletedList = (state: RootState) =>
    state.work.checkoutCompletedList;

export const selectPointById = createSelector(
    [selectPoints, selectStringParam],
    (points, pointId) => points?.[pointId],
);

interface SelectTaskByIdParams {
    targetId: string;
    taskId: string;
}

export const selectTaskById = createSelector(
    [selectTasks, selectParams<SelectTaskByIdParams>],
    (tasks, { taskId, targetId }) => tasks?.[targetId]?.[taskId],
);

export const selectCheckoutByOrderId = createSelector(
    [selectCheckoutList, selectStringParam],
    (checkoutList, orderId) => checkoutList?.[orderId],
);

export const selectCheckoutCompletedByOrderId = createSelector(
    [selectCheckoutCompletedList, selectStringParam],
    (checkoutCompletedList, orderId) => checkoutCompletedList?.[orderId],
);
